import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=46a6e742&scoped=true&lang=pug&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6e742",
  null
  
)

export default component.exports